import unescape from 'lodash/unescape';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import IconMarker from '@spothero/icons/marker';
import Button from '@spothero/ui/button';
import Select from '@spothero/ui/select';
import {setSortType} from 'search/search-actions';
import SegmentUtils from 'utils/segment';
import SpotUtils from 'utils/spot';

const FILTER_OPTIONS = [
    {
        label: 'Featured',
        value: SpotUtils.airportFilterValues.FEATURED,
    },
    {
        label: 'Shuttle Time',
        value: SpotUtils.airportFilterValues.SHUTTLE_TIME,
    },
    {
        label: 'Price',
        value: SpotUtils.airportFilterValues.PRICE,
    },
    {
        label: 'Location Name',
        value: SpotUtils.airportFilterValues.ALPHABETICAL,
    },
];

class SearchAirportFilters extends Component {
    static propTypes = {
        destinationTitle: PropTypes.string.isRequired,
        sortBy: PropTypes.string,
        spotCount: PropTypes.number.isRequired,
        onChangeSort: PropTypes.func.isRequired,
        onToggleViewType: PropTypes.func.isRequired,
    };

    componentDidMount() {
        SegmentUtils.track({
            event: 'List Landing',
        });
    }

    _onFilterChange = ({value}) => {
        this.props.onChangeSort(value);
    };

    _displaySpotCount(spotCount) {
        return `${spotCount > 0 ? `${spotCount} ` : ''}Parking Spot${
            spotCount === 1 ? '' : 's'
        }`;
    }

    render() {
        const {
            destinationTitle,
            spotCount,
            sortBy,
            onToggleViewType,
        } = this.props;

        return (
            <div className="SearchAirportFilters">
                <div className="SearchAirportFilters-form">
                    <Select
                        defaultValue={sortBy}
                        onChange={this._onFilterChange}
                        items={FILTER_OPTIONS}
                    />
                    <Button
                        color="tertiary"
                        iconPosition="right"
                        onClick={onToggleViewType}
                    >
                        View Map <IconMarker />
                    </Button>
                </div>
                <div className="SearchAirportFilters-count">
                    <strong>{this._displaySpotCount(spotCount)}</strong> Near{' '}
                    <strong>{unescape(destinationTitle)}</strong>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        search: {
            data: {sortBy},
        },
        destination: {
            data: {title: destinationTitle},
        },
    } = state;

    return {
        destinationTitle,
        sortBy,
    };
};

const mapDispatchToProps = {
    onChangeSort: setSortType,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchAirportFilters);
